import { render, staticRenderFns } from "./IconCustomer.vue?vue&type=template&id=23e4cde2&"
import script from "./IconCustomer.vue?vue&type=script&lang=js&"
export * from "./IconCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports